export default function Social({ userData, onChange, fieldErrors = {} }) {
  return (
    <div className="bg-white rounded-lg sm:rounded-xl lg:rounded-2xl shadow-sm sm:shadow-md lg:shadow-lg overflow-hidden">
      <div className="p-3 sm:p-4 md:p-5 lg:p-6 border-b border-gray-100 bg-gradient-to-r from-gray-50 to-white">
        <h3 className="text-sm sm:text-base md:text-lg lg:text-xl font-semibold text-gray-900 flex items-center gap-1 sm:gap-2">
          Social Profiles
        </h3>
        <p className="mt-0.5 sm:mt-1 text-xs sm:text-sm md:text-base text-gray-600">
          Connect your social media accounts
        </p>
      </div>

      <div className="p-3 sm:p-4 md:p-5 lg:p-6 space-y-3 sm:space-y-4 md:space-y-5 lg:space-y-6">
        <div className="grid grid-cols-1 gap-3 sm:gap-4 md:gap-5 lg:gap-6 md:grid-cols-2">
          <div className="space-y-1 sm:space-y-2">
            <label
              htmlFor="social.x"
              className="block text-xs sm:text-sm md:text-base font-medium sm:font-semibold text-gray-700 flex items-center gap-1 sm:gap-2"
            >
              X
            </label>
            <input
              type="text"
              name="social.x"
              id="social.x"
              value={userData.social.x}
              onChange={onChange}
              className={`block w-full px-2 py-2 sm:px-3 sm:py-2.5 md:px-4 md:py-3 text-xs sm:text-sm md:text-base border rounded-lg sm:rounded-xl focus:ring-1 sm:focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-300 bg-gray-50 focus:bg-white ${
                fieldErrors["social.x"]
                  ? "border-red-300 focus:ring-red-500"
                  : "border-gray-200"
              }`}
              placeholder="https://x.com/yourusername"
            />
            {fieldErrors["social.x"] && (
              <p className="text-xs text-red-600 mt-1">
                {fieldErrors["social.x"]}
              </p>
            )}
          </div>

          <div className="space-y-1 sm:space-y-2">
            <label
              htmlFor="social.instagram"
              className="block text-xs sm:text-sm md:text-base font-medium sm:font-semibold text-gray-700 flex items-center gap-1 sm:gap-2"
            >
              Instagram
            </label>
            <input
              type="text"
              name="social.instagram"
              id="social.instagram"
              value={userData.social.instagram}
              onChange={onChange}
              className={`block w-full px-2 py-2 sm:px-3 sm:py-2.5 md:px-4 md:py-3 text-xs sm:text-sm md:text-base border rounded-lg sm:rounded-xl focus:ring-1 sm:focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-300 bg-gray-50 focus:bg-white ${
                fieldErrors["social.instagram"]
                  ? "border-red-300 focus:ring-red-500"
                  : "border-gray-200"
              }`}
              placeholder="https://instagram.com/yourusername"
            />
            {fieldErrors["social.instagram"] && (
              <p className="text-xs text-red-600 mt-1">
                {fieldErrors["social.instagram"]}
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
